export enum CashPayment {
  True = 'true'
}

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type ProviderFilterTypes = {
  state?: string
  insuranceId?: string
  cash_payment?: string
  // Todo: remove name with FF pedp-3858-booking-insurance-id
  insurance?: string
  concern?: string[]
  typeOfCare?: string
  gender?: string[]
  identity?: string[]
  day?: string[]
  time?: string[]
  pageIndex?: string
  time_slot?: string
  test?: string
  city?: string
}

export enum DayEnum {
  MONDAY = 'Monday',
  TUESDAY = 'Tuesday',
  WEDNESDAY = 'Wednesday',
  THURSDAY = 'Thursday',
  FRIDAY = 'Friday',
  SATURDAY = 'Saturday',
  SUNDAY = 'Sunday'
}

export enum TimePeriodEnum {
  EARLY_MORNING = 'Early Morning (Before 10am)',
  MORNING = 'Morning (10am - Noon)',
  AFTERNOON = 'Afternoon (Noon - 5pm)',
  EVENING = 'Evening (After 5pm)'
}

export enum StatesEnum {
  TEXAS = 'TX',
  VIRGINIA = 'VA',
  ILLINOIS = 'IL',
  NEW_YORK = 'NY',
  GEORGIA = 'GA',
  MASSACHUSETTS = 'MA',
  FLORIDA = 'FL',
  DISTRICT_OF_COLUMBIA = 'DC',
  MARYLAND = 'MD',
  NEVADA = 'NV',
  NEW_JERSEY = 'NJ',
  MICHIGAN = 'MI',
  LOUISIANA = 'LA',
  PENNSYLVANIA = 'PA',
  OREGON = 'OR',
  CONNECTICUT = 'CT',
  TENNESSEE = 'TN',
  MAINE = 'ME',
  NORTH_CAROLINA = 'NC',
  ALABAMA = 'AL',
  ARKANSAS = 'AR',
  VERMONT = 'VT'
}

export enum InsurancesEnum {
  CASH = 'Cash',
  // Todo: remove all except Cash with 'pedp-3858-booking-insurance-id'
  AETNA = 'Aetna',
  BCBS = 'Blue Cross Blue Shield',
  CIGNA = 'Cigna',
  OSCAR = 'Oscar Health',
  OXFORD = 'Oxford',
  UHC = 'UnitedHealthcare'
}

export enum GenderEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  NON_BINARY = 'NON_BINARY'
}

export enum ConcernsEnum {
  ADDICTION = 'Addiction',
  ADHD = 'ADHD',
  ANGER_MANAGEMENT = 'Anger Management',
  ANXIETY = 'Anxiety',
  BIPOLAR = 'Bipolar Disorder',
  CAREER = 'Career',
  COPING_SKILLS = 'Coping Skills',
  DEPRESSION = 'Depression',
  DISSOCIATIVE_DISORDERS = 'Dissociative Disorders',
  EATING_DISORDERS = 'Eating Disorders',
  FAMILY_CONFLICT = 'Family Conflict',
  GRIEF = 'Grief',
  LEARNING_DISABILITIES = 'Learning Disabilities',
  LGBTQ = 'LGBTQ+',
  MENS_ISSUES = "Men's Issues",
  MOOD_DISORDERS = 'Mood Disorders',
  OCD = 'Obsessive-Compulsive Disorder(OCD)',
  PARENTING = 'Parenting',
  RELATIONSHIPS = 'Relationships',
  PERSONALITY_DISORDERS = 'Personality Disorders',
  SELF_ESTEM = 'Self Esteem',
  SEXUAL_ABUSE = 'Sexual Abuse',
  SPIRITUALITY = 'Spirituality',
  TRAUMA_PTSD = 'Trauma and PTSD',
  WOMENS_ISSUES = "Women's Issues"
}

export enum TypeOfCareEnum {
  THERAPY = 'Talk Therapy',
  MEDICATION_MANAGEMENT = 'Medication Management'
}

export enum IdentitiesEnum {
  ASIAN = 'Asian / Asian American',
  BLACK = 'Black / African American',
  BUDDHIST = 'Buddhist',
  CHRISTIAN = 'Christian',
  HINDU = 'Hindu',
  HISPANIC = 'Hispanic / Latinx',
  JEWISH = 'Jewish',
  LGBTQ = 'LGBTQ',
  MUSLIM = 'Muslim',
  NATIVE_AMERICAN = 'Native American',
  MIDDLE_EASTERN = 'Middle Eastern/North African',
  PACIFIC_ISLANDER = 'Pacific Islander',
  POC = 'Person of Color (POC)',
  WHITE = 'White',
  MIXED = 'Mixed/two or more'
}

export enum TreatmentMethodsEnum {
  ACT = 'Acceptance and Commitment Therapy (ACT)',
  CBT = 'Cognitive Behavioral Therapy (CBT)',
  DBT = 'Dialectical Behavior Therapy (DBT)',
  EMDR = 'Eye Movement Desensitization and Reprocessing (EMDR)',
  Exposure = 'Exposure Therapy',
  PersonCentered = 'Person-Centered Therapy',
  Interpersonal = 'Interpersonal Therapy',
  MBCT = 'Mindfulness-Based (MBCT)',
  MI = 'Motivational Interviewing (MI)',
  Psychodynamic = 'Psychodynamic Therapy',
  SFBT = 'Solution-Focused Brief Therapy (SFBT)',
  StrengthBased = 'Strength-Based Therapy',
  TraumaFocused = 'Trauma Focused Therapy'
}
